// extracted by mini-css-extract-plugin
export default {"root":"DuplicatesPreviewVariant2__root--1llQd","img":"DuplicatesPreviewVariant2__img--1T1gs"};